import { FC, useCallback } from 'react';
import { AgentCallerIdConfirmationModal } from '@pages/agent/InboxPage/components/AgentCallerIdConfirmationModal';
import { useOutboundCallModalContext } from '../OutboundCallModal/context';
import { DYNAMIC_CALLER_ID_NUMBER } from '@components/OutboundCallerIdSelection/constants';
import { Contact } from '@api/generated/graphql';
import { mainLayoutLocators } from '@locators/main-layout';
import { OutboundCallDetails } from '../OutboundCallModal/types';

export interface TechnicianConfirmationModalProps {
  details: OutboundCallDetails;
  onClose: () => void;
}

export const TechnicianConfirmationModal: FC<
  TechnicianConfirmationModalProps
> = ({ details, onClose }) => {
  const { outboundCall } = useOutboundCallModalContext();

  const handleCall = useCallback(
    async (callerId: string) => {
      const callerNumber =
        callerId === DYNAMIC_CALLER_ID_NUMBER ? null : callerId || null;
      await outboundCall({
        phoneNumber: details.number,
        customerName: details.callDisplayName,
        callerNumber,
        tenantId: details.tenantId,
      });
      onClose();
    },
    [outboundCall, details, onClose],
  );

  return (
    <AgentCallerIdConfirmationModal
      customerName={details.callDisplayName}
      contact={{ value: details.number } as Contact}
      tenantId={details.tenantId ?? ''}
      onClose={onClose}
      onCall={handleCall}
      callButtonId={
        mainLayoutLocators.outboundAndTransferModal.technicianCallBtn
      }
    />
  );
};
